import React, { useEffect, useState } from "react";
import { DescriptionPeriodValue } from "../../../layout";
import {
  formatDateHourToBR,
  saveData,
} from "../../../functions/functionsUtility";
import { getData } from "../../../functions/request";

export default function PetroleoWti() {
  const [cotacoesData, setCotacoesData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    getData("petroleo_wti", "getLastPetroleoWti", "insertPetroleoWti")
      .then((data) => {
        console.log(data);
        setCotacoesData(data);
      })
      .finally(() => {
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        setHasError(err?.message ?? "Ocorreu um erro.");
        console.log(err);
      });
  }, []);

  return (
    <>
      <DescriptionPeriodValue
        title={"Petróleo - WTI"}
        onClickButton={() => saveData(cotacoesData)}
        date={formatDateHourToBR(cotacoesData.data)}
        // inputValue={cotacoesData.fechamento}
        state={cotacoesData}
        setState={setCotacoesData}
        stateKey={"fechamento"}
        isLoading={isLoading}
        hasError={hasError}
      />
    </>
  );
}
